import Splide from '@splidejs/splide';

(($, Drupal) => {
  const initCardsCarousel = (el) => {
    const slides = $(el).find('.splide__slide');
    const whatsons = $(el).hasClass('cards-carousel--whatsons');
    const largeCards = $(el).hasClass('cards-carousel--large-cards');
    const mediumCards = $(el).hasClass('cards-carousel--medium-cards');
    const showArrows = slides && (largeCards ? slides.length > 3 : slides.length > 4);

    const slider = new Splide(el, {
      type: 'slide',
      drag: true,
      arrows: showArrows,
      pagination: true,
      trimSpace: true,
      autoWidth: mediumCards ? false : true,
      autoHeight: true,
      speed: 600,
      mediaQuery: 'min',
      classes: {
        arrows: 'splide__arrows',
        arrow: 'splide__arrow cards__arrow btn btn--icon-filled',
        prev: 'splide__arrow--prev cards__arrow--prev btn--icon-chevron-left',
        next: 'splide__arrow--next cards__arrow--next btn--icon-chevron-right',
        pagination: 'splide__pagination cards__pagination',
      },
      breakpoints: {
        320: {
          drag: true,
          pagination: true,
          arrows: showArrows,
          gap: '0.75rem',
          perPage: 1,
        },
        768: {
          drag: true,
          pagination: true,
          arrows: showArrows,
          gap: '1rem',
          perPage: 2,
        },
        1024: {
          arrows: showArrows,
          gap: '1rem',
          perPage: mediumCards ? 4 : 3,
        },
        1440: {
          perPage: whatsons ? 3 : largeCards ? 3 : 4,
          arrows: showArrows,
          gap: '1.5rem',
        },
        1920: {
          arrows: whatsons ? false : showArrows,
          gap: '2rem',
        },
      },
    });

    // const updateHeight = () => {
    //   const { slide } = slider.Components.Slides.getAt(slider.index);
    //   slide.parentElement.style.height = `${slide.offsetHeight}px`;
    // };

    // slider.on('active resized', updateHeight);

    slider.on('mounted move', () => {
      const arrowPrev = $(el).find('.splide__arrow--prev');
      const arrowNext = $(el).find('.splide__arrow--next');

      if (slider.index === 0) {
        $(arrowPrev).addClass('hidden');
      } else {
        $(arrowPrev).removeClass('hidden');
      }

      if (!largeCards) {
        if (window.innerWidth < 768) {
          if (slider.index === slides.length - 1) {
            $(arrowNext).addClass('hidden');
          } else {
            $(arrowNext).removeClass('hidden');
          }
        }

        if (window.innerWidth >= 768 && window.innerWidth < 1024) {
          if (slider.index + 1 === slides.length - 1) {
            $(arrowNext).addClass('hidden');
          } else {
            $(arrowNext).removeClass('hidden');
          }
        }

        if (window.innerWidth >= 1024 && window.innerWidth < 1440) {
          if (slider.index + 2 === slides.length - 1) {
            $(arrowNext).addClass('hidden');
          } else {
            $(arrowNext).removeClass('hidden');
          }
        }

        if (window.innerWidth >= 1440) {
          if (slider.index + 3 === slides.length - 1) {
            $(arrowNext).addClass('hidden');
          } else {
            $(arrowNext).removeClass('hidden');
          }
        }
      } else if (window.innerWidth >= 1024) {
        if (slider.index + 2 === slides.length - 1) {
          $(arrowNext).addClass('hidden');
        } else {
          $(arrowNext).removeClass('hidden');
        }
      }
    });

    slider.mount();

    // updateHeight();

    // $(window).on('resize', () => {
    //   updateHeight();
    // });
  };

  Drupal.behaviors.mstCardsCarousel = {
    attach: (context) => {
      $('.cards-carousel', context).each((index, element) => {
        const splideNumber = `splide-cards-carousel-${index}`;
        $(element).addClass(splideNumber);
        $(element).attr('id', splideNumber);
        initCardsCarousel(`.${splideNumber}`);
      });
    },
  };
})(jQuery, Drupal);
